/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const loginPageStyle = {
  background: (theme: Theme) => ({
    paddingTop: "5rem",
    paddingBottom: "2.5rem",
    [theme.breakpoints.down("md")]: {
      height: "70vh",
      minHeight: "600px",
    },
  }),
  loginContainer: {
    maxWidth: "23rem",
  },
  imgDescription: {
    marginTop: "2.5rem",
    maxWidth: "100%",
  },
  loginContent: {
    padding: "1.5rem",
  },
  loginTitle: {
    fontSize: "1.25rem",
    textAlign: "center",
    padding: "1rem 1.5rem",
    fontWeight: 500,
    color: "primary.main",
    borderBottom: "1px solid #f4f4f4",
  },
};

export default loginPageStyle;
